import { Car, FileText, Home } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { VehicleDocForm } from "@/components/VehicleDocForm";
import { IMAGES } from "@/constants/images";

const documents = [
  {
    icon: Car,
    title: "Permis de conduire",
    text: "En cours de validité, au nom du conducteur du véhicule loué.",
  },
  {
    icon: FileText,
    title: "Carte d'identité",
    text: "Pièce d'identité en cours de validité du conducteur.",
  },
  {
    icon: Home,
    title: "Justificatif de domicile",
    text: "De moins de 3 mois : facture d'énergie, attestation, quittance...",
  },
];

export default function LocationVehiculePage() {
  return (
    <div data-testid="location-vehicule-page">
      <PageHero
        image={IMAGES.occasions}
        imageAlt="Location de véhicule chez MECA AUTO CLEAN 01 à Pont-d'Ain"
        imageTestid="location-bg-image"
        eyebrow="Location de véhicule"
        title="Louez un véhicule à Pont-d'Ain"
      >
        Besoin d'une voiture pour quelques jours ? MECA AUTO CLEAN 01 propose la
        location de véhicules, sur devis. Envoyez votre demande avec vos
        documents : nous vous répondons directement sur votre téléphone.
      </PageHero>

      <section className="border-t border-border">
        <div className="mx-auto max-w-6xl px-4 py-20">
          <Reveal>
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.25em] text-primary">
              Votre dossier
            </p>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Documents à fournir
            </h2>
            <p className="mt-4 max-w-2xl text-muted-foreground">
              Trois documents suffisent pour constituer votre demande de
              location. Vous pouvez les joindre directement ci-dessous.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-3">
            {documents.map((d, i) => (
              <Reveal key={d.title} delay={i * 0.08}>
                <div
                  data-testid={`location-doc-${i + 1}`}
                  className="h-full rounded-lg border border-border bg-card p-6 transition-colors card-lift hover:border-primary/50"
                >
                  <d.icon className="h-7 w-7 text-primary" />
                  <h3 className="mt-4 font-semibold">{d.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{d.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-panel border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-20">
          <Reveal>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Demande de location
            </h2>
            <p className="mb-8 mt-4 text-muted-foreground">
              Vos documents sont transmis au garage avec votre demande, par
              e-mail sécurisé. Le garage vous répond avec les disponibilités et
              le tarif.
            </p>
          </Reveal>
          <div className="rounded-lg border border-border bg-card p-6">
            <VehicleDocForm kind="location" kindLabel="Location de véhicule" />
          </div>
        </div>
      </section>
    </div>
  );
}
